var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8579 15.1716L12.7583 12.072C15.2644 9.2127 15.1538 4.85944 12.4264 2.13203C9.58369 -0.710678 4.97475 -0.710678 2.13203 2.13203C-0.710678 4.97475 -0.710678 9.58369 2.13203 12.4264C4.85944 15.1538 9.2127 15.2644 12.072 12.7583L15.1716 15.8579C15.3611 16.0474 15.6684 16.0474 15.8579 15.8579C16.0474 15.6684 16.0474 15.3611 15.8579 15.1716ZM11.7399 2.81837C14.2035 5.28205 14.2035 9.27647 11.7399 11.7402C9.27618 14.2038 5.28176 14.2038 2.81808 11.7402C0.354391 9.27647 0.354391 5.28205 2.81808 2.81837C5.28176 0.354685 9.27618 0.354685 11.7399 2.81837Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.a2b86292cbc7ea8edd545000fb4d3e40.svg";
export { ForwardRef as ReactComponent };